import React from "react";
//import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
//import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
//import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalMui(props) {
  const {
    modalShow,
   // showModal,
    closeModal,
    modalTitle,
  //  modalContent,
  //  submitMethod,
  } = props;

  const handleClose = () => {
    if(closeModal)closeModal();
  };

 /* const onSubmit = () => {
    submitMethod();
  };*/

  return (
    <div>
      <Dialog
        open={modalShow}
        TransitionComponent={Transition}
        maxWidth="md"
        keepMounted
        disableBackdropClick={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{modalTitle}</DialogTitle>
        <DialogContent>{props.children}</DialogContent>
      </Dialog>
    </div>
  );
}
